import React, { useEffect } from 'react'

interface Props {
  children: JSX.Element | JSX.Element[]
  isOpen: boolean
  toggleModal: () => void
}

const Modal = ({ children, isOpen, toggleModal }: Props) => {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('overflow-hidden')
    } else {
      document.body.classList.remove('overflow-hidden')
    }
  }, [isOpen])
  if (!isOpen) {
    return <></>
  }

  return (
    <>
      <div className="fixed min-w-[100vw] min-h-[100vh] top-0 left-0 bg-[rgba(0,0,0,0.35)] z-50 flex justify-center overflow-scroll max-h-[80vh]">
        {children}
      </div>
      <div
        onClick={toggleModal}
        className="fixed top-0 left-0 p-2 px-[1.1rem] m-4 border-white border rounded-full font-sans text-18 z-50 cursor-pointer text-white">
        x
      </div>
    </>
  )
}

export default Modal
